import { Box } from '@mui/material';
import type { ReactNode } from 'react';
import type { Sx } from '../layouts/types';

interface IconProps {
  sx?: Sx;
}

const Icon = ({
  sx,
  children,
  fill = 'none',
  strokeWidth = 2,
}: IconProps & { children: ReactNode; fill?: string; strokeWidth?: number }) => (
  <Box
    component="svg"
    viewBox="0 0 24 24"
    fill={fill}
    stroke={fill === 'none' ? 'currentColor' : 'none'}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
    sx={sx}
  >
    {children}
  </Box>
);

export const CheckIcon = (props: IconProps) => (
  <Icon strokeWidth={2.2} {...props}>
    <path d="M20 6L9 17l-5-5" />
  </Icon>
);

export const PlusIcon = (props: IconProps) => (
  <Icon strokeWidth={2.2} {...props}>
    <path d="M12 5v14M5 12h14" />
  </Icon>
);

export const ClockIcon = (props: IconProps) => (
  <Icon {...props}>
    <circle cx="12" cy="13" r="8" />
    <path d="M12 9v4l2.5 2.5M9 2h6" />
  </Icon>
);

export const ArrowIcon = (props: IconProps) => (
  <Icon {...props}>
    <path d="M5 12h14M13 6l6 6-6 6" />
  </Icon>
);

export const SparkIcon = (props: IconProps) => (
  <Icon {...props}>
    <path d="M13 2L4.5 13.5H11l-1 8.5L18.5 10H12z" />
  </Icon>
);

export const StarIcon = (props: IconProps) => (
  <Icon {...props}>
    <path d="M12 2l2.4 7.2H22l-6 4.6 2.3 7.2-6.3-4.5-6.3 4.5L8 13.8 2 9.2h7.6z" />
  </Icon>
);

export const QuestionIcon = (props: IconProps) => (
  <Icon {...props}>
    <circle cx="12" cy="12" r="9" />
    <path d="M9.5 9a2.5 2.5 0 115 0c0 1.7-2.5 2-2.5 3.6M12 17h.01" />
  </Icon>
);

export const RefreshIcon = (props: IconProps) => (
  <Icon {...props}>
    <path d="M21 12a9 9 0 11-6.2-8.56M21 3v6h-6" />
  </Icon>
);

export const PlayIcon = (props: IconProps) => (
  <Icon fill="currentColor" {...props}>
    <path d="M8 5.5v13l11-6.5z" />
  </Icon>
);

export const PhoneIcon = (props: IconProps) => (
  <Icon {...props}>
    <path d="M22 16.9v3a2 2 0 01-2.2 2 19.8 19.8 0 01-8.6-3.1 19.5 19.5 0 01-6-6A19.8 19.8 0 012.1 4.2 2 2 0 014.1 2h3a2 2 0 012 1.7c.1 1 .4 2 .7 2.9a2 2 0 01-.5 2.1L8 10a16 16 0 006 6l1.3-1.3a2 2 0 012.1-.5c.9.3 1.9.6 2.9.7a2 2 0 011.7 2z" />
  </Icon>
);

export const MailIcon = (props: IconProps) => (
  <Icon {...props}>
    <rect x="2" y="4" width="20" height="16" rx="3" />
    <path d="M22 7l-10 6L2 7" />
  </Icon>
);

export const DocumentIcon = (props: IconProps) => (
  <Icon {...props}>
    <path d="M14 2H7a2 2 0 00-2 2v16a2 2 0 002 2h10a2 2 0 002-2V7z" />
    <path d="M14 2v5h5M9 13h6M9 17h6" />
  </Icon>
);

export const LogoMarkIcon = (props: IconProps) => (
  <Icon {...props}>
    <circle cx="6" cy="7" r="3" />
    <circle cx="18" cy="7" r="3" />
    <circle cx="12" cy="17" r="3" />
    <path d="M8.5 9l2 5.5M15.5 9l-2 5.5" />
  </Icon>
);
